/**
 * Health check endpoint: GET /api/health
 * Ported from dashboard/app/api/health/route.ts.
 *
 * In TanStack Start, API-style routes use createServerFileRoute
 * or are handled via server functions. For simple JSON endpoints,
 * we use a server function called from a route loader.
 */
import { createFileRoute } from '@tanstack/react-router'
import { createServerFn } from '@tanstack/react-start'
import { setResponseHeader } from '@tanstack/react-start/server'

const healthCheck = createServerFn({ method: 'GET' }).handler(async () => {
  setResponseHeader('content-type', 'application/json')
  return {
    status: 'ok',
    timestamp: new Date().toISOString(),
  }
})

export const Route = createFileRoute('/api/health')({
  loader: () => healthCheck(),
  component: () => null,
})
